import moment from 'moment';

import { HourEntryFragment } from '@common/graphql/schema';

export const parseInTz = (date: string, tz?: string | null): moment.Moment => {
  let parsed = moment.parseZone(date);
  if (tz) {
    parsed = parsed.tz(tz);
  }

  return parsed;
};

export const maybeParseInTz = (
  date: string | undefined | null,
  tz?: string | null
): moment.Moment | undefined => {
  if (!date) {
    return;
  }

  return parseInTz(date, tz);
};

export const parseHourEntryDates = (entry: HourEntryFragment) =>
  [
    parseInTz(entry.startedAt!, entry.startedAtTz),
    parseInTz(entry.endedAt!, entry.endedAtTz),
  ] as const;

export const withMinutesPrecision = (date: moment.Moment | undefined) =>
  date?.seconds(0)?.milliseconds(0);
